import { BusinessUnit } from '#models/business-unit';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '#services/shared';
import { BusinessUnitsService, UserService } from '#services/api';
import { Utility } from '#services/shared/utility';
import { BusinessUnitStorageService } from '#services/shared/business-unit-storage.service';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LanguageLookupService } from '#services/api/language-lookup.service';
import { TranslateInPipe } from '#pages/shared/pipes/translate-in.pipe';
import { Language } from '#services/translate/languages';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-functional-review-header',
  templateUrl: './functional-review-header.component.html',
  styleUrls: ['./functional-review-header.component.scss'],
  providers: [TranslateInPipe],

})
export class FunctionalReviewHeaderComponent implements OnInit {
  //#region VARIABLES
  selectedBU: BusinessUnit;
  lstBusinessUnit: BusinessUnit[] = [];

  //#endregion

  currentBusinessUnit$: Observable<BusinessUnit>;
  currentUser$: Observable<any>;

  availableLanguages = [];
  selectedLanguage: any;

  constructor(
    private authSvc: AuthService,
    private businessUnitService: BusinessUnitsService,
    private businessUnitStorageService: BusinessUnitStorageService,
    private translateService: TranslateService,
    private languageLookupService: LanguageLookupService,
    private translateInPipe: TranslateInPipe,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.currentBusinessUnit$ = this.businessUnitStorageService.currentBusinessUnit$;

    this.currentUser$ = this.authSvc.loggedUser$;

    if ('initNavbarJS' in window) {
      (<any>window).initNavbarJS();
    }

    this.selectedLanguage =
      this.translateService.currentLang || localStorage.getItem('lang') || 'en';

    this.languageLookupService
      .getLanguagesPreferences()
      .toPromise()
      .then((languages) => {
        this.availableLanguages = languages;
      });
  }

  userGuideClick() {
    window.open(
      'https://chevron.sharepoint.com/:f:/r/sites/Surface-FacilityandEquipmentOperationsProductLine/Shared%20Documents/Process%20Safety/Mobile%20PSSR/PSSR%20Tutorial%20and%20Guide?csf=1&web=1&e=XQCRPW', '_blank');
  }

  loadBusinessUnits(): void {
    this.businessUnitService.getUserBUs().subscribe((data: BusinessUnit[]) => {
      this.lstBusinessUnit = data;
      if (this.lstBusinessUnit.length > 0) {
        this.selectedBU = this.lstBusinessUnit[0];
        this.selectedBU.PssrTitle = Utility.getPssrTitle(this.selectedBU);
      }
    });
  }

  translateIn(val: string, lang: Language) {
    return this.translateInPipe.transform(val, lang);
  }

  selectLanguage(language: Language) {
    this.translateService.use(language);

    this.userService
      .savePreferences({
        language,
      })
      .pipe(take(1))
      .subscribe(
        () => {
          this.authSvc.setCurrentUser({
            PreferredLanguage: language,
          });
        },
        console.error
      );
  }
}
